import api from "../api/client";
import { ACTIVE_PAGES } from "../constants/pageMaster";

const SESSION_KEY = "hrportal_analytics_session_id";
const PAGE_KEY = "hrportal_analytics_page_key";
const TAB_KEY = "hrportal_analytics_tab_name";

function newId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getAnalyticsSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = newId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function analyticsPageForPath(pathname) {
  const candidates = ACTIVE_PAGES.filter(
    (page) => pathname === page.route || pathname.startsWith(`${page.route}/`)
  ).sort((a, b) => b.route.length - a.route.length);
  return candidates[0] || null;
}

export function setCurrentAnalyticsPage(page) {
  if (!page) {
    sessionStorage.removeItem(PAGE_KEY);
    sessionStorage.removeItem(TAB_KEY);
    return;
  }
  sessionStorage.setItem(PAGE_KEY, page.pageKey);
  sessionStorage.setItem(TAB_KEY, page.label);
}

export function trackAnalyticsEvent(event) {
  if (!localStorage.getItem("token")) return Promise.resolve();
  const payload = {
    eventId: newId(),
    occurredAt: new Date().toISOString(),
    schemaVersion: 1,
    sessionId: getAnalyticsSessionId(),
    source: "hr_portal_web",
    ...event,
  };
  return api.post("/analytics/events", payload).catch(() => {
    // Analytics must never interrupt the user's portal workflow.
  });
}

export function trackFeatureUse({
  actionName,
  featureName,
  entityType,
  entityId,
  success = true,
  durationMs,
  metadata,
} = {}) {
  const tabName = sessionStorage.getItem(TAB_KEY) || null;
  return trackAnalyticsEvent({
    eventType: "feature_use",
    pageKey: sessionStorage.getItem(PAGE_KEY) || undefined,
    tabName: tabName || undefined,
    featureName: featureName || tabName || undefined,
    actionName: actionName || undefined,
    entityType: entityType || undefined,
    entityId: entityId || undefined,
    success,
    durationMs,
    metadata,
  });
}

// Opt-in UI tracking for actions that never reach the API (opening a dialog,
// switching a tab, applying a filter). Only data attributes are reported: the
// clicked element's text is deliberately ignored because on this portal it
// frequently contains candidate and employee names.
export function installInteractionTracking() {
  if (typeof document === "undefined" || document.__hrAnalyticsInteractions) return;
  document.__hrAnalyticsInteractions = true;

  document.addEventListener("click", (event) => {
    if (!localStorage.getItem("token")) return;
    const target = event.target?.closest?.("[data-analytics-action]");
    if (!target) return;
    trackFeatureUse({
      actionName: target.getAttribute("data-analytics-action"),
      featureName: target.getAttribute("data-analytics-feature") || undefined,
      entityType: target.getAttribute("data-analytics-entity") || undefined,
      entityId: target.getAttribute("data-analytics-entity-id") || undefined,
      metadata: { source: "ui_click" },
    });
  });
}

export function trackLogin(method) {
  return trackAnalyticsEvent({
    eventType: "login",
    actionName: "login_success",
    success: true,
    metadata: { method },
  });
}